<template>
  <DashboardBaseSidebar :is-sidebar-shown="isSidebarShown" @close="emitClose">
    <DashboardAdminSidebarNav v-if="isAdmin" @navigate="emitNavigate" @go-back="handleGoBack" />
    <IconBtn
      v-else
      class="admin-go-back"
      variation-class-name="admin-go-back"
      prepend-icon-class-name="fr fr-chevron-left"
      label="Back to Opportunities"
      flat
      @click="handleGoBack"
    />
  </DashboardBaseSidebar>
</template>

<script setup lang="ts">
  // Types
  import type { RouteLocationNormalizedLoaded } from 'vue-router';

  // Components
  import DashboardBaseSidebar from '~/modules/dashboard/sidebar/base/DashboardBaseSidebar.vue';
  import DashboardAdminSidebarNav from '~/modules/dashboard/admin/sidebar/nav/DashboardAdminSidebarNav.vue';
  import IconBtn from '~/misc/btn/icon/IconBtn.vue';

  defineProps({
    isSidebarShown: {
      type: Boolean,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      required: true,
    },
  });

  const emit = defineEmits<{
    (e: 'navigate', route: RouteLocationNormalizedLoaded | string): void;
    (e: 'close'): void;
  }>();

  const handleGoBack = () => emitNavigate('/');

  const emitNavigate = (route: RouteLocationNormalizedLoaded | string) => emit('navigate', route);

  const emitClose = () => emit('close');
</script>
